import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, FormGroup, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { Auth, SignOut, CheckGroupMembership, CheckGroupName } from '../../../functions/ZIA'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBroom, faPaste, faCopy, faI } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Multiselect from 'multiselect-react-dropdown';

function CheckGroupMembershipTab({ groups }) {
    library.add(faBroom, faPaste, faCopy)
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [tenant, setTenant] = useState("Rheintec");
    const [group, setGroup] = useState("");
    const [memberConsole, setMemberConsole] = useState("");
    const [nonMemberConsole, setNonMemberConsole] = useState("");
    const [members, setMembers] = useState([])
    const [nonMembers, setNonMembers] = useState([])
    const [failedUsers, setFailedUsers] = useState([])
    const [userText, setUserText] = useState("");
    const [userList, setUserList] = useState([]);
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const [JSESSIONID, setJSESSIONID] = useState("");
    const membersTextRef = useRef();
    const nonMembersTextRef = useRef();
    const [validated, setValidated] = useState(false);
    const multiselectRef = useRef();

    const handleSelectGroup = (selectedList) => {
        if (selectedList.length > 0) {
            setGroup(selectedList[0].name);
        } else {
            setGroup('');
        }
    };

    function appendMemberConsole(text) {
        setMemberConsole(prevOutput => prevOutput + text);
    }
    function appendNonMemberConsole(text) {
        setNonMemberConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine, member) {
        const width = membersTextRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        if (member) {
            appendMemberConsole((skipNewLine ? "" : "\n") + dashes);
            return;
        }
        appendNonMemberConsole((skipNewLine ? "" : "\n") + dashes);

    }
    function appendConsoleSeperatorSecondary(member) {
        const width = membersTextRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        if (member) {
            appendMemberConsole("\n" + "\t" + dashes);
            return;
        }
        appendNonMemberConsole("\n" + "\t" + dashes);
    }


    function copyList(list) {
        const text = ListToText(list);
        navigator.clipboard.writeText(text);
    }

    function ListToText(list) {
        let text = "";
        for (let i = 0; i < list.length; i++) {
            text += i === 0 ? list[i] : "\n" + list[i];
        }
        return text;
    }
    function replaceUsers(list) {
        const text = ListToText(list);
        setUserText(text);
    }


    function clearUserText() {
        setUserText("");
    }

    async function handleSubmit(event) {

        //Prerequisites
        setMemberConsole(``);
        setNonMemberConsole(``);
        setMembers([]);
        setFailedUsers([]);
        setNonMembers([]);
        setUserList([]);
        setLoading(true);
        event.preventDefault();

        //Authenticate
        setLoadingMessage("Initiating Session...");
        const json_session = await Auth(tenant);
        const session = json_session.session;
        setJSESSIONID(session);
        console.log(session);

        //Check Group Name
        setLoadingMessage("Checking group name...");
        const group_response = await CheckGroupName(group, session, tenant);
        if (group_response.status != 200) {
            const response_data = await group_response.json();
            console.log(`\nError: ${response_data.message}`);
            appendMemberConsole("Error: " + response_data.message);
            appendNonMemberConsole("Error: " + response_data.message);
            terminateSession(session);
            return;
        }
        //Read Users
        setLoadingMessage("Reading user list...");
        let users = userText.split('\n');
        users = users.map((user) => user.trim()).filter((user) => user !== "")
        setUserList(users);

        //Check Memberships
        setLoadingMessage(`Checking memberships...`);
        for (const user of users) {
            try {
                let response = await CheckGroupMembership(user, group, session, tenant)
                const response_data = await response.json();
                if (response.status === 200) {
                    console.log(response_data["isMember"])
                    if (response_data["isMember"]) {
                        setMembers((prev) => [...prev, response_data.user])
                    } else {
                        setNonMembers((prev) => [...prev, response_data.user])
                    }
                }
                else {
                    setFailedUsers((prev) => [...prev, { user: response_data.user, message: response_data.message }]);
                }

            }
            catch (error) {
                setFailedUsers((prev) => [...prev, { user: user }]);
            }
        }


    }

    useEffect(() => {
        if (failedUsers.length > 0) {
            setLoadingMessage(`Checking memberships  (${nonMembers.length + members.length + failedUsers.length}/${userList.length})`);
            const failedUser = failedUsers[failedUsers.length - 1];
            appendNonMemberConsole(`${failedUsers.length + nonMembers.length > 1 ? "\n" : ""}${failedUser.user} (${failedUser.message})`);
            if (nonMembers.length + members.length + failedUsers.length == userList.length) {
                terminateSession(JSESSIONID);
            }
        }

    }, [failedUsers]);

    useEffect(() => {
        if (nonMembers.length > 0) {
            setLoadingMessage(`Checking memberships  (${nonMembers.length + members.length + failedUsers.length}/${userList.length})`);
            const nonMember = nonMembers[nonMembers.length - 1];
            appendNonMemberConsole(`${failedUsers.length + nonMembers.length > 1 ? "\n" : ""}${nonMember}`);
            if (nonMembers.length + members.length + failedUsers.length == userList.length) {
                terminateSession(JSESSIONID);
            }
        }

    }, [nonMembers]);

    useEffect(() => {
        if (members.length > 0) {
            setLoadingMessage(`Checking memberships (${nonMembers.length + members.length + failedUsers.length}/${userList.length})`);
            const member = members[members.length - 1];
            appendMemberConsole(`${members.length > 1 ? "\n" : ""}${member}`);
            if (nonMembers.length + members.length + failedUsers.length == userList.length) {
                terminateSession(JSESSIONID);
            }
        }
    }, [members]);

    // Function to scroll the textarea to the bottom
    function scrollToBottom(textRef) {
        textRef.current.scrollTop = textRef.current.scrollHeight;
    };

    function scrollToTop(textRef) {
        textRef.current.scrollTop = 0;
    };

    useEffect(() => {
        scrollToBottom(membersTextRef);
    }, [memberConsole])

    useEffect(() => {
        scrollToBottom(nonMembersTextRef);
    }, [nonMemberConsole])

    useEffect(() => {
        scrollToTop(membersTextRef);
        scrollToTop(nonMembersTextRef);
    }, [isLoading])

    useEffect(() => {
        setGroup('')
        multiselectRef.current.resetSelectedValues();
    }, [tenant])
    async function terminateSession(JSESSIONID) {
        //Signout
        setLoadingMessage("Terminating Session...");
        await SignOut(JSESSIONID, tenant);
        setLoading(false);
    }

    return (
        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form validated={validated} onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                Select tenant
                            </Form.Label>
                            <Form.Select aria-label="Default select example" value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    Object.keys(groups).map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="groupName" className='mt-4'>
                            <Form.Label>
                                {groups[tenant].length === 0 ? <Spinner
                                    variant='light'
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                /> : <></>}
                                &nbsp;&nbsp;Group Name
                            </Form.Label>
                            <Multiselect
                                key={`${tenant}-${groups[tenant].length}`}
                                options={groups[tenant].map(groupName => ({ name: groupName, id: groupName }))}
                                displayValue="name"
                                onSelect={handleSelectGroup}
                                onRemove={handleSelectGroup}
                                ref={multiselectRef}
                                selectionLimit={1}
                                placeholder="Select Group"
                                showCheckbox="true"
                                showArrow="true"
                                customArrow={<FontAwesomeIcon icon="fa-solid fa-angle-down" style={{ color: "#c6cbce", }} size='sm' />}

                            />
                        </FormGroup>

                        <FormGroup controlId="userList" className='mt-4'>
                            <Form.Label className='w-100' >
                                <Container fluid className='pe-0'>
                                    <Row>
                                        <Col className='col-md-auto'>
                                            <div className=''>User List</div>
                                        </Col>
                                        <Col className='text-end'>
                                            <Button disabled={members.length > 0 ? false : true} onClick={(e) => replaceUsers(members)} className='me-1 m-0 pt-0 pb-0 pm-1 rounded-0' variant={members.length > 0 ? "danger" : "primary"} size='sm' >
                                                <FontAwesomeIcon className='me-1' icon="fa-solid fa-paste" style={{ color: "#ffffff", }} />
                                                Replace with members <Badge bg="dark">{members.length}</Badge>
                                            </Button>
                                            <Button disabled={nonMembers.length > 0 ? false : true} onClick={(e) => replaceUsers(nonMembers)} className='me-1 m-0 pt-0 pb-0 pm-1 rounded-0' variant={nonMembers.length > 0 ? "danger" : "primary"} size='sm' >
                                                <FontAwesomeIcon className='me-1' icon="fa-solid fa-paste" style={{ color: "#ffffff", }} />
                                                Replace with non-memebers <Badge bg="dark">{nonMembers.length}</Badge>
                                            </Button>
                                            <Button disabled={failedUsers.length > 0 ? false : true} onClick={(e) => replaceUsers(failedUsers.map((fail) => fail.user))} className='me-1 m-0 pt-0 pb-0 pm-1 rounded-0' variant={failedUsers.length > 0 ? "danger" : "primary"} size='sm' >
                                                <FontAwesomeIcon className='me-1' icon="fa-solid fa-paste" style={{ color: "#ffffff", }} />
                                                Replace with failed users <Badge bg="dark">{failedUsers.length}</Badge>
                                            </Button>
                                            <Button disabled={userText === "" ? true : false} onClick={(e) => clearUserText()} variant='primary' size='sm' className=' m-0 pt-0 pb-0 pm-1 rounded-0 text-light'>
                                                <FontAwesomeIcon className='me-1' size='sm' icon="fa-solid fa-broom" style={{ color: "#ffffff", }} />
                                                Clear users
                                            </Button>
                                        </Col>
                                    </Row>
                                </Container>

                            </Form.Label>
                            <Form.Control required value={userText} onChange={(e) => setUserText(e.target.value)} rows={5} as="textarea" placeholder="user1@rheintec.ch&#10;user2@rheintec.ch&#10;...." />
                        </FormGroup>



                        <Button className='mt-4 text-light' variant="primary" type='submit' disabled={isLoading || !group} >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : 'Check group membership'}
                        </Button>
                        <ProgressBar className='mt-4' now={isLoading ? ((failedUsers.length + members.length + nonMembers.length) / userList.length) * 100 : 0} />
                    </Form>
                </Col>
            </Row>
            <Row className='text-end mt-4'>
                <Col>
                    <Button disabled={members.length > 0 ? false : true} onClick={(event) => { copyList(members) }} className='rounded-0 pt-0 pb-0 pm-1' size='sm' variant={members.length > 0 ? 'success' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy members
                        <Badge className='ms-1' bg="dark">{members.length}</Badge>
                    </Button>
                </Col>
                <Col>
                    <Button disabled={failedUsers.length > 0 ? false : true} onClick={(event) => { copyList(failedUsers.map(fail => fail.user)) }} className='ms-1 rounded-0 pt-0 pb-0 pm-1' size='sm' variant={failedUsers.length > 0 ? 'danger' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy failed users
                        <Badge className='ms-1' bg="dark">{failedUsers.length}</Badge>
                    </Button>
                    <Button disabled={nonMembers.length > 0 ? false : true} onClick={(event) => { copyList(nonMembers) }} className='ms-1 rounded-0 pt-0 pb-0 pm-1' size='sm' variant={nonMembers.length > 0 ? 'danger' : 'primary'}>
                        <FontAwesomeIcon className='me-1' size='lg' icon="fa-solid fa-copy" style={{ color: "#ffffff", }} />
                        Copy non memebrs
                        <Badge className='ms-1' bg="dark">{nonMembers.length}</Badge>
                    </Button>
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea ref={membersTextRef} value={memberConsole} className='w-100 bg-dark-subtle text-rheintec-blue' rows="15" disabled>
                    </textarea>
                </Col>


                <Col className=''>
                    <textarea ref={nonMembersTextRef} value={nonMemberConsole} className='w-100 bg-dark-subtle text-rheintec-blue' rows="15" disabled>
                    </textarea>
                </Col>

            </Row>

        </Container >

    );
}

export default CheckGroupMembershipTab;